import { render, staticRenderFns } from "./badgeList.vue?vue&type=template&id=0884ca8a&scoped=true"
import script from "./badgeList.vue?vue&type=script&lang=js"
export * from "./badgeList.vue?vue&type=script&lang=js"
import style0 from "./badgeList.vue?vue&type=style&index=0&id=0884ca8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884ca8a",
  null
  
)

export default component.exports